import {Component, EventEmitter, Input, Output} from '@angular/core';
import {LabelDataDto} from '../../../../../Models/YuChef/Labeled/labeled.interface';

@Component({
  selector: 'app-labeled-button',
  templateUrl: './labeled-button.component.html',
  styleUrls: ['./labeled-button.component.scss'],
  standalone: false
})
export class LabeledButtonComponent {
  @Input() label!: LabelDataDto;
  @Input() isExpired: boolean = false;

  @Output() clickBtn = new EventEmitter<void>();
  @Output() clickOptionsBtn = new EventEmitter<void>();
  @Output() clickFavBtn = new EventEmitter<void>();
}
